import WarningIcon from '@mui/icons-material/Warning';
import { JobsSortCols } from "Components/JobsTs/JobsModel";
import { IConfirmationDialogLabels } from "Components/SharedComponents/ConfirmationDialog/ConfirmationDialogModel";
import { ISortParamsBase, ITableHeadersBase, ITableHeadersOptions } from "shared/SharedModels";

export const JobsHeaders: (ITableHeadersBase<JobsSortCols, JobsSortCols> & ITableHeadersOptions)[] = [
    { columName: 'city', label: 'City', order: 4, isSortable: false, columNameInDb: 'city' },
    { columName: 'hiring_manager', label: 'Hiring Manager', order: 3, isSortable: false, columNameInDb: 'hiring_manager' },
    { columName: 'owner', label: 'Owner', order: 2, isSortable: false, columNameInDb: 'owner' },
    { columName: 'state', label: 'State', order: 5, isSortable: false, columNameInDb: 'state' },
    { columName: 'name', label: 'Title', order: 1, isSortable: true, columNameInDb: 'name' },
    { columName: 'starts_at', label: 'Start Date', order: 6, isSortable: true, columNameInDb: 'created_at' },
    { columName: 'ends', label: 'End Date', order: 7, isSortable: false, columNameInDb: 'updated_at' },
];

export const DefaultJobsSortParams: ISortParamsBase<JobsSortCols> = {
    orderBy: 'created_at', order: 'desc'
}

export const StopHiringConfirmationLabels: IConfirmationDialogLabels = {
    title: <WarningIcon color='warning' fontSize='large' />,
    contentText: `If you stop your job, people won't be able to apply anymore. 
    Also, you'd have to pay for another posting if you wanted to start hiring again. Be super sure!`,
    confirmButtonLabel: `Yes, stop hiring`,
    cancelButtonLabel: `Continue Hiring`
}

export const DeleteJobConfirmationLabels: IConfirmationDialogLabels = {
    title: 'Delete This Job',
    contentText: `Confirm that you want to delete this Job. This action is irreversible.`,
    confirmButtonLabel: `Confirm`,
    cancelButtonLabel: `Cancel`
}
